import React, { PureComponent } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import TeamReport from './team-report/index';
import TeamPitcher from './team-pitcher/index';
import TeamBatter from './team-batter/index';
import './style.scss';
import TeamStarter from './team-starter';
import Tab from './tab/index';
import TeamSchedule from './team-schedule';
import TeamPublic from './team-public/index';
import TeamAddTopic from './team-add-topic/index';
import TeamUserTopic from './team-user-topic';
import { ACTIONS_MASTER, getMasterTeam } from './../../../actions/master';
import { detectIconById } from '../../../common/enum';
import Loading from '../../../components/loading';

const dataRoute = [
    {
        link : '/team-report/:id',
        component : TeamReport
    },
    {
        link : '/team-report/:id/pitcher',
        component : TeamPitcher
    },
    {
        link : '/team-report/:id/batter',
        component : TeamBatter
    },
    {
        link : '/team-report/:id/starter',
        component : TeamStarter
    },
    {
        link : '/team-report/:id/schedule',
        component : TeamSchedule
    },
    {
        link : '/team-report/:id/public',
        component : TeamPublic
    },
    {
        link : '/team-report/:id/topic/:topicId',
        component : TeamUserTopic
    },
    {
        link : '/team-report/add-topic',
        component : TeamAddTopic
    },
];

class Team extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            titleTeam : '',
            teamName: '',
            dataRoute: dataRoute,
            locationKey: '',
            loading: false,
        }
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.getMasterTeam(id);
        this.setState({
            teamId : id
        });
    }

    componentDidUpdate(prevProps) {
        if(this.props.match.params.id !== prevProps.match.params.id) {
            const id = this.props.match.params.id;
            this.setState({locationKey: prevProps.location.key, loading: true, teamId: id});
            this.props.getMasterTeam(id).then(() => {
                this.setState({loading: false});
            });
        }
    }

    showTitle(text) {
        this.setState({
            titleTeam : text
        })
    }

    showPageInTeam(data) {
        return data.map((val, i) => {
            return(
                <Route key={i} path={ val.link} exact render={( props ) => {
                    return(
                        <val.component { ...props } titleTeamReport={(text) => this.showTitle(text)} teamName={this.state.teamName}/>
                    )
                }}  />
            )
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.status === ACTIONS_MASTER.GET_MASTER_TEAM_SUCCESS) {
            this.setState({
                teamName: nextProps.response.team_name
            })
        }
    }

    render() {
        return (
            <div className="team">
                <div className="block-title">
                    { detectIconById(this.state.teamId) ? <img className="block-title__text--sub" src={detectIconById(this.state.teamId)} alt="Alt text" /> : null }
                    <h2 className="block-title__text--main">{ this.state.teamName }</h2>
                </div>

                <Tab />
                {!this.state.loading && <Switch>
                    {
                        this.showPageInTeam(this.state.dataRoute)
                    }
                </Switch>
                }
                <Loading show={this.state.loading}/>
            </div>
        );
    }
}

const mapStateToProps = ({ master }) => {
    return {
        response: master.response,
        status: master.status
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTeam: (id) => dispatch(getMasterTeam(id))
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(Team);
